window.Api = {	
	
	genToken: function(id){
		
		MyFacture.post("prefsApi", "do=gentoken&id="+id, function(response){
			Utils.reload();
		});

	},
	
	genAppForm : function(id){

		id = undefined == id ? "" : id;
		var options = {
			title	: id.length > 0 ? Loc.g("Modification de l'application") : Loc.g("Ajout d'une application"),
			buttons	: [
					{text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}},
					{text : Loc.g("Enregistrer"), click : function(){$("#genAppForm").submit();}},
				],
			callback	: function(){Api.prepareGenForm();}
		};
		MyWindow.load("prefsApi", {'do':"genappform", 'id':id}, options);
		MyFacture.customForm();
		
	},
	
	prepareGenForm : function(){
		
		var formId = "genAppForm";
		var options = {success:function(data){Api.recordGenCallback(data);}, dataType:"json"};
		MyForm.prepare(formId, "prefsApi&do=recordgenform", options, true);
		MyFacture.initEvent("#"+formId);
		
	},
	
	recordGenCallback : function(data){
		
		var formIsOk = MyForm.processJson(data, "genAppForm");
		if(formIsOk){
			Utils.reload();
		}
		
	},
	
	regenToken : function(type, id){
		
		var msg =  Loc.g("Attention, en régénerant votre token vous devez le modifier dans le code de votre application. Voulez vous continuer ?");
		var options = {
			resizable	: false,
			noclose		: true,
			type		: "warning",
			title		: Loc.g("Régénération d'un token"),
			buttons		: [
						{text : Loc.g("Non"), click : function(){$(this).dialog("close")}},
						{text : Loc.g("Oui"), click : function(){Api.doRegenToken(type, id, $(this));}},
					]
			
		};
		MyWindow.alert(msg, options);
		
	},
	
	doRegenToken: function(type, id, me){
		
		 MyFacture.post("prefsApi", "do=regentoken&type="+type+"&id="+id, function(response){
				if (response.tokendata.error == 'N'){
					$('#'+type+"_token_"+id).html(response.tokendata.data.token);
					$('#'+type+"_secret_"+id).html(response.tokendata.data.secret);
					me.dialog("close");
				} else {
					me.dialog("close");
					var msg =  Loc.g("Vous n'avez pas accès au token que vous essayez de modifier.");
					var options = {
						resizable	: false,
						noclose		: true,
						type		: "error",
						title		: Loc.g("Erreur lors de la régénération"),
						buttons		: [{
							text : "Ok",
							click : function() {
								$(this).dialog('close');
							}}]
					}
					MyWindow.alert(msg, options);
				}
			}, "json");
			
	},
	
	revokeToken: function(id, cid){
	
		var msg =  Loc.g("Attention, en supprimant l'accès à cette application vous devrez vous re-connecter à celle ci lors de votre prochaine utilisation");
		var options = {
			resizable	: false,
			noclose		: true,
			type		: "warning",
			title		: Loc.g("Révoquer l'application"),
			buttons		: [
				{text : Loc.g("Non"), click : function(){$(this).dialog("close")}},
				{text : Loc.g("Oui"), click : function(){Api.doRevokeToken(id, cid, $(this));}},
			]
		};
		MyWindow.alert(msg, options);

	},
	
	doRevokeToken: function(id, cid, me){
		
		 MyFacture.post("prefsApi", "do=revoketoken&id="+id, function(response){
				if (response.tokendata.error == 'N'){
					Utils.reload();
				} else {
					me.dialog("close");
					var msg =  Loc.g("Un problème est survenu");
					var options = {
						resizable	: false,
						noclose		: true,
						type		: "error",
						title		: Loc.g("Erreur"),
						buttons		: [{
							text : Loc.g("Ok"),
							click : function() {$(this).dialog('close');}}
							]
					}
					MyWindow.alert(msg, options);
				}
			}, "json");
	},
	
	deleteApp: function(id){
		var msg =  Loc.g("Attention, en supprimant cette application, les utilisateurs ne pourrons plus y accéder.");
		var options = {
			resizable	: false,
			noclose		: true,
			type		: "warning",
			title		: Loc.g("Suppression d'une application"),
			buttons		: [
				{text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
				{text : Loc.g("Oui"), click : function(){Api.doDeleteApp(id, $(this));}}
			]
		};
		MyWindow.alert(msg, options);
	},
	
	doDeleteApp: function(id, me){
		
		MyFacture.post("prefsApi", "do=deleteApp&id="+id, function(response){
			if (response.appdata.error == 'N'){
				Utils.reload();
			} else {
				me.dialog("close");
				var msg =  Loc.g("Vous n'avez pas le droit de supprimer cette application");
				var options = {
					resizable	: false,
					noclose		: true,
					type		: "error",
					title		: Loc.g("Erreur lors de la suppression"),
					buttons		: [{
						text : Loc.g("Ok"),
						click : function() {$(this).dialog('close');}}
						]
				}
				MyWindow.alert(msg, options);
			}
		}, "json");
	},
	
	editAccess: function(id){

		var options = {
			title	: Loc.g("Modification de l'accès"),
			buttons	: [
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}},
				{text : Loc.g("Enregistrer"), click : function(){$("#accessAppForm").submit();}},
			],	
			callback	: function(){Api.prepareAccessEditForm();}
		};
		MyWindow.load("prefsApi", {'do':"accessappform", 'id':id}, options);
		MyFacture.customForm();
		
		
	},
	
	prepareAccessEditForm : function(){
		
		var formId = "accessAppForm";
		var options = {success:function(data){Api.recordAccessEditCallback(data);}, dataType:"json"};
		MyForm.prepare(formId, "prefsApi&do=recordaccessappform", options, true);
		MyFacture.initEvent("#"+formId);
		
	},
	
	recordAccessEditCallback : function(data){
		
		var formIsOk = MyForm.processJson(data, "accessAppForm");
		if(formIsOk){
			Utils.reload();
		}
	}
};
